module.exports = __webpack_public_path__ + "img/logo-text.321d0dc2.png";